// Generated types for ChangeProposal
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ProposalOperation, ProposalStatus } from '../enums';

import { RFLPElementReadAPI, RFLPElementWriteAPI } from './rflpelement';
import { RFLPElementReadAPISchemaObject, RFLPElementWriteAPISchemaObject } from './rflpelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ChangeProposalReadAPI extends RFLPElementReadAPI {
  /** UUID of the entity to be mutated (or parent reference for CREATE). */
  target_entity_id: string;
  /** Short type name of the target entity. */
  target_entity_type: string;
  /** Shape of the proposed mutation. */
  operation?: ProposalOperation;
  /** JSON-encoded snapshot of pre-change fields (empty for CREATE). */
  before_json?: string | null;
  /** JSON-encoded shape of post-change fields (empty for DELETE). */
  after_json?: string | null;
  /** Agent's reasoning, displayed to reviewers. */
  rationale?: string;
  /** Lifecycle: PENDING → APPROVED|REJECTED → APPLIED|SUPERSEDED. */
  status?: ProposalStatus;
  /** Agent's 0–1 confidence; drives default sort in the review UI. */
  confidence?: number | null;
}

export interface ChangeProposalWriteAPI extends RFLPElementWriteAPI {
  /** UUID of the entity to be mutated (or parent reference for CREATE). */
  target_entity_id: string;
  /** Short type name of the target entity. */
  target_entity_type: string;
  /** Shape of the proposed mutation. */
  operation?: ProposalOperation;
  /** JSON-encoded snapshot of pre-change fields (empty for CREATE). */
  before_json?: string | null;
  /** JSON-encoded shape of post-change fields (empty for DELETE). */
  after_json?: string | null;
  /** Agent's reasoning, displayed to reviewers. */
  rationale?: string;
  /** Lifecycle: PENDING → APPROVED|REJECTED → APPLIED|SUPERSEDED. */
  status?: ProposalStatus;
  /** Agent's 0–1 confidence; drives default sort in the review UI. */
  confidence?: number | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ChangeProposalReadAPISchema: z.ZodType<ChangeProposalReadAPI> = RFLPElementReadAPISchemaObject.extend({
  target_entity_id: z.string(),
  target_entity_type: z.string(),
  operation: z.nativeEnum(ProposalOperation).optional(),
  before_json: z.string().nullable().optional(),
  after_json: z.string().nullable().optional(),
  rationale: z.string().optional(),
  status: z.nativeEnum(ProposalStatus).optional(),
  confidence: z.number().nullable().optional(),
}).passthrough();

export const ChangeProposalWriteAPISchema: z.ZodType<ChangeProposalWriteAPI> = RFLPElementWriteAPISchemaObject.extend({
  target_entity_id: z.string(),
  target_entity_type: z.string(),
  operation: z.nativeEnum(ProposalOperation).optional(),
  before_json: z.string().nullable().optional(),
  after_json: z.string().nullable().optional(),
  rationale: z.string().optional(),
  status: z.nativeEnum(ProposalStatus).optional(),
  confidence: z.number().nullable().optional(),
}).passthrough();
